module.exports = __webpack_public_path__ + "static/media/progress-gems-earned.dc723601.svg";